// generated from 48 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const churnCategoryFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("churn_category_filter"),
  comparison_key: z.enum([
    "1", // 47 (97.92%)
    "2", // 1 (2.08%)
  ]),
  display_name: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 13 (27.08%), defined 35 (72.92%)
  raw_value: z
    .enum([
      "high risk", // 26 (74.29%)
      "medium risk", // 6 (17.14%)
      "low risk", // 3 (8.57%)
    ])
    .optional(),
  value: z.enum([
    "high risk", // 34 (70.83%)
    "medium risk", // 9 (18.75%)
    "low risk", // 5 (10.42%)
  ]),
  varies_by_app_group: z.literal(false),
});
